import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-skeletal',
  template: `
          <div class="skeleton p-0 m-0">
            <ng-container *ngFor="let row of getRowChunks()">
              <div class="skeleton_form_section" >
                  <ng-container *ngFor="let field of row">
                    <div class="skeleton_form_item">
                      <div class="line skeleton_form_item_label"></div>
                      <div class="line skeleton_form_item_field"></div>
                    </div>
                  </ng-container>
              </div>
            </ng-container>
          </div>
  `,
  styles: [`
      .skeleton_form_item {
        flex: 1 1 auto;
        flex-direction: column;
      }

      .border_radius_6{
        border-radius: 6px;
      }

      .skeleton_form_section {
        display: flex;
        flex-direction: row;
        gap: 15px;
        margin-bottom: 20px;
      }
      .skeleton_form_item_field{
        height: 35px;
        margin-top: 10px;
        border-radius: 4px;
      }
      .skeleton_form_item_label{
        width: 75%
      }
    `]
})
export class FormSkeletalComponent {
  @Input() rows: number = 5;
  @Input() fieldsPerRow: number = 4;

  constructor() { }

  ngOnInit(): void { }

  getRowChunks(): number[][] {
    const totalFields = Array.from({ length: this.rows * this.fieldsPerRow }, (_, i) => i);
    const chunks = [];
    for (let i = 0; i < totalFields.length; i += this.fieldsPerRow) {
      chunks.push(totalFields.slice(i, i + this.fieldsPerRow));
    }
    return chunks;
  }
}
